import type React from "react";
import { useT } from "i18n";

export interface ConfirmAlertProps {
  children?: React.ReactElement | React.ReactElement[];
  isOpen?: boolean;
  description: string;
  onClose?: () => void;
}

export default function ConfirmAlert({
  children,
  isOpen = false,
  description,
  onClose,
}: ConfirmAlertProps): React.ReactElement {
  const t = useT();
  if (!isOpen) return <></>;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "4px",
          width: "500px",
          height: "auto",
          maxHeight: "90vh",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
        }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div
          style={{
            padding: "12px",
            borderBottom: "1px solid #e1e5e9",
            fontSize: "15px",
            fontWeight: "700",
            textAlign: "left",
          }}
        >
          {t("component.confirmAlert.warning", "Warning!")}
        </div>

        <div
          style={{
            padding: "12px 12px 20px",
            flex: 1,
            overflow: "auto",
            fontSize: "15px",
            textAlign: "left",
            lineHeight: "1.5em",
          }}
        >
          {description}
        </div>

        {children && (
          <div
            style={{
              padding: "12px 12px 12px",
              borderTop: "1px solid #e1e5e9",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            {children}
          </div>
        )}
      </div>
    </div>
  );
}
